const handler = cf => {
  const parent = $(cf);
  const fileListContainer = $('.c-form__custom-upload-files-list');
  const fileInput = parent.find('.c-form__file-upload');

  $(fileInput).on('change', function() {
    let items = [];
    parent.addClass('has-file');
    $.each(fileInput.prop('files'), (_, file) => {
      items.push(`<li>${file.name} <button type="button">x</button></span></li>`);
    });

    fileListContainer.append($(`
      <ul>
        ${items.join()}
      </ul>
    `));

    fileListContainer.find('button').on('click', function(ev) {
      ev.preventDefault();
      $(fileInput).val('');
      fileListContainer.html('');
      parent.removeClass('has-file')
    })
  });
};

const customFileField = container => {
  const fileFields = $(container).find('.js-form-file');

  if (!fileFields.length) return;
  
  fileFields.each(function() {
    handler(this);
  });
};

export default customFileField;


// WEBPACK FOOTER //
// ./scripts/util/customFileField.js